var exports = {
  "uW": "x43aef4ae--fe1920--section",
  "dM": "x43aef4ae--fe1920--background-image",
  "Lw": "x43aef4ae--fe1920--overlay",
  "Qs": "x43aef4ae--fe1920--content",
  "wx": "x43aef4ae--fe1920--header",
  "DD": "x43aef4ae--fe1920--title",
  "h_": "x43aef4ae--fe1920--description",
  "h3": "x43aef4ae--fe1920--description-text",
  "Ip": "x43aef4ae--fe1920--chips",
  "nR": "x43aef4ae--fe1920--card-panels",
  "uC": "x43aef4ae--fe1920--card-panel",
  "kR": "x43aef4ae--fe1920--cards",
};

module.exports = exports;
